import React, { useCallback } from 'react'
import { Segment, Header, Container, Message } from 'semantic-ui-react'
import DataTable from '../components/data_table'
import { filterTypes, formatNumber, handleRedirect } from '../helpers'
import { getProducts } from '../api/tripletex/products'
import { useNavigate } from 'react-router-dom'
import Link from '../components/link'

export default function InventoryPage() {
	const routerNavigateFn = useNavigate()

	const apiSearch = useCallback(async (query, options, requestOptions) => {
		const res = await getProducts(query, options, requestOptions)
		handleRedirect(res, routerNavigateFn)
		return res
	}, [routerNavigateFn])

	return <>
		<Segment vertical padded="very">
			<Container>
				<Header size="huge">
					Lagerbeholdning
					<Header.Subheader>Liste over alle produkter og lagerstatus</Header.Subheader>
				</Header>

				<Message
					info
					icon="info circle"
					header="Bruk Webmercs (Konsept-IT Nettbutikk)"
					content={<>
					<p>Lagerbeholdning skal hovedsakelig sjekkes i <Link href="https://admin.webmercs.com/admin/PartsManagement/PartsManagement.asp" target="_blank">Webmercs</Link>. Logg på, velg distributør "Konsept-IT" og trykk Søk.</p>
					<p>Denne siden er kun til unntakstilfeller hvor produkter ikke finnes i Webmercs.</p>
				</>} />

				<p>Søkefeltet leter først etter resultater på produktnr, deretter produktnavn hvis ingen resultater på førstnevnte.<br/>For å søke på kun produktnr eller produktnavn, eller kun vise varer på lager, trykk "Filtrer". <strong>OBS! Ikke søk på både produktnr og produktnavn.</strong></p>

				<DataTable
					format="tripletex"
					columns={[
						{ key: 'number', text: 'Produktnr.', visible: true, sortable: true, searchable: true, filterType: filterTypes.search },
						{ key: 'name', text: 'Produktnavn', visible: true, sortable: true, searchable: true, filterType: filterTypes.search },
						{ key: 'priceExcludingVatCurrency', text: 'Pris (eks. mva)', visible: true },
						{ key: 'priceIncludingVatCurrency', text: 'Pris (inkl. mva)', visible: true },
						{ key: 'stockOfGoods', text: 'Ant. på lager', visible: true },
						{ key: 'availableStock', text: 'Tilgj. antall', visible: true },
						{ key: 'isStockItem', filterText: 'På lager', filterType: filterTypes.boolean },
					]}
					defaultOrder={{'Name': 'ASC'}}
					apiSearch={apiSearch}
					renderRow={data => [
						data.number,
						data.name,
						formatNumber(data.priceExcludingVatCurrency, { precision: 2 }) + ' kr',
						formatNumber(data.priceIncludingVatCurrency, { precision: 2 }) + ' kr',
						data.stockOfGoods,
						data.availableStock,
					]}
				/>
			</Container>
		</Segment>
	</>
}